/** True when Tower/dev builds bake VITE_APP_ENV=development|staging. Never on Pages prod. */
export function isStagingAppEnv(): boolean {
  const env = String(import.meta.env.VITE_APP_ENV ?? '').trim().toLowerCase();
  return env === 'development' || env === 'dev' || env === 'staging';
}

/** Persistent high-contrast strip — only rendered when `VITE_APP_ENV` is development/staging. */
export default function StagingEnvBanner() {
  if (!isStagingAppEnv()) return null;
  return (
    <div
      role="status"
      data-marshal-env="staging"
      className="bg-orange-600 px-3 py-1 text-center text-[11px] font-bold tracking-[0.14em] text-white"
    >
      STAGING
    </div>
  );
}
